<template>
    <div class="flex mb-4 rounded-lg  overflow-hidden">
        <div class=" w-3/12 border-r shadow-sm border-gray-200">
            <div class="p-3 border-b border-gray-200 shadow-sm text-center cursor-pointer tab"
                 :class="{'active':active == panel}"
                 @click="openPanel($event,panel)" v-for="panel,index in panels" :key="index">
                {{ separateCamelCase(panel) }}
            </div>
        </div>
        <div class=" w-9/12">
            <div class="p-6 bg-white border-b shadow-sm border-gray-200 tabpanel" :class="{'active':active == panel}"
                 :id="panel" v-for="panel,index in panels" :key="index">
                <slot :name="panel"></slot>
            </div>
        </div>
    </div>
</template>
<script>
import {getParameters, makeParameter, separateCamelCase, setPath} from "../../Utils/Common";

export default {
    props: ['panels'],
    data() {
        return {
            active: this.panels[0],
        }
    },
    methods: {
        separateCamelCase,
        openPanel(event, panelName) {
            // Declare all variables
            var i, tabpanel, tab;

            // Get all elements with class="tabpanel" and hide them
            tabpanel = document.getElementsByClassName("tabpanel");
            for (i = 0; i < tabpanel.length; i++) {
                tabpanel[i].style.display = "none";
            }

            // Get all elements with class="tab" and remove the class "active"
            tab = document.getElementsByClassName("tab");
            for (i = 0; i < tab.length; i++) {
                tab[i].className = tab[i].className.replace(" active", "");
            }

            // Show the current tab, and add an "active" class to the button that opened the tab
            document.getElementById(panelName).style.display = "block";
            event.currentTarget.className += " active";
            const parems = makeParameter('activeTab', panelName);
            setPath(parems);
        }
    },
    mounted() {
        const parems = getParameters();
        if (parems?.activeTab) {
            const index = this.panels.findIndex(item => item.toLowerCase() == parems.activeTab.toLowerCase());
            this.active = this.panels[index];
        }
    }

}
</script>
<style>
.tab {
    position: relative;
    background: #fff;
}

.tab.active {
    background: #1F2937;
    color: #fff;
}

.tab.active::after {
    content: '';
    width: 0;
    height: 0;
    border-top: 24px solid transparent;
    border-left: 20px solid #1F2937;
    border-bottom: 24px solid transparent;
    position: absolute;
    top: 0;
    bottom: 0;
    right: -10px;
}

.tabpanel {
    display: none;
}

.tabpanel.active {
    display: block;
}
</style>
